import { MutationNames } from '@/constants/MutationNames';
import { IState } from '@/interfaces/IState';

export default {
  [MutationNames.UPDATE_PRIMARY_LICENSE](state: IState, license: string) {
    state.primaryLicense = license.toUpperCase();
  },
  [MutationNames.LOG_IN](state: IState, loginData: { authToken: string, role: number }) {
    state.isLoggedIn = true;
    state.authToken = loginData.authToken;
    state.role = loginData.role;

    localStorage.authToken = loginData.authToken;
    localStorage.role = loginData.role;
  },
  [MutationNames.LOG_OUT](state: IState) {
    state.isLoggedIn = false;
    state.licenses = [];
    state.prefix = '';
    state.firstName = '';
    state.lastName = '';
    state.authToken = '';
    state.primaryLicense = '';
    state.email = '';
    state.articles = [];
    state.fullName = '';
    state.balance = 0;
    state.orders = [];

    localStorage.authToken = '';
    localStorage.role = '';
  },
};
